exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-061c3f4d]{width:1050px;margin:50px auto;border:1px solid #eee}.bor_style[data-v-061c3f4d]:not(:last-child){margin-left:-18px;margin-right:-18px;border-bottom:1px solid #eadadd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-061c3f4d","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/info_manage/add_categary_agree/category_brand.vue
// module id = 333
// module chunks = 0